
import Vue from 'vue';
import { Icon, Button } from '@descomplica/vue-components';
import { ListItemModel, ListModel } from '@descomplica/dex-models';
import { TranslateResult } from 'vue-i18n';
import i18n from '../i18n';
import VideoIconButton from './VideoIconButton.vue';

interface Data {
  progress: number;
  countdown: any;
}

export default Vue.extend({
  components: {
    Icon,
    Button,
    VideoIconButton,
  },
  props: {
    handlerNextListItem: {
      type: Function,
      required: true,
    },
    handlerReplay: {
      type: Function,
      required: true,
    },
    nextList: {
      type: Object as Vue.PropType<ListModel | null>,
      default: null,
    },
    nextListItem: {
      type: Object as Vue.PropType<ListItemModel | null>,
      default: null,
    },
  },
  data(): Data {
    return {
      progress: 0,
      countdown: null,
    };
  },
  computed: {
    title(): string {
      if (this.nextListItem) {
        if (this.nextListItem.isVideo()) return this.nextListItem.video.name;
        if (this.nextListItem.isArticle()) return this.nextListItem.article.title;
        if (this.nextListItem.isQuestion()) {
          if (this.nextListItem.isObjective()) {
            return i18n.tc('question', 2);
          }
          if (this.nextListItem.isDiscursive()) {
            return i18n.tc('trivia');
          }
        }
      }
      return this.nextList ? this.nextList.name : '';
    },
    caption(): TranslateResult {
      if (this.nextListItem) {
        if (this.nextListItem.isVideo()) return i18n.t('nextVideo');
        return i18n.t('nextActivity');
      }
      return i18n.tc('nextList');
    },
  },
  mounted() {
    if (this.nextListItem && this.nextListItem.isVideo()) {
      this.startCountdown();
    }
  },
  destroyed() {
    if (this.countdown) clearInterval(this.countdown);
  },
  methods: {
    onHandlerNextItem() {
      clearInterval(this.countdown);
      this.handlerNextListItem();
    },
    onHandlerReplay() {
      clearInterval(this.countdown);
      this.handlerReplay();
    },
    startCountdown() {
      this.countdown = setInterval(this.progressIncrement, 50);
    },
    progressIncrement() {
      this.progress += 0.5;
      if (this.progress >= 100) {
        clearInterval(this.countdown);
        this.handlerNextListItem();
      }
    },
  },
});
